import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ConfigurationService } from '@draeger-academy/common';

@Component({
    selector: 'da-select',
    templateUrl: './select.component.html',
    styleUrls: ['./select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SelectComponent implements OnInit {
    @Input() options: any[];
    @Input() variable: any[];
    @Input() title: any[];
    @Input() disable: false;
    selectedValue: string = null;
    @Output()
    change: EventEmitter<string> = new EventEmitter<string>();
    public hasFocus = false;
    constructor(
        private _configurationService: ConfigurationService
    ) {}

    ngOnInit() {
        const isPortal = this._configurationService.isPartnerPage();

        let _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();
        this.onSelect(sessionStorage.getItem(`${this.variable}${_site}`));
    }

    public onSelect(selectedValue) {
        const isPortal = this._configurationService.isPartnerPage();

        let _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();

        if (this.options && this.options[0] && (!selectedValue || selectedValue === null || selectedValue === 'undefined')) {
            selectedValue = this.options[0].key;
            this.selectedValue = selectedValue;
        } else {
            this.selectedValue = selectedValue;
        }

        this.change.emit(selectedValue);
    }

    public reset(variable) {
        const isPortal = this._configurationService.isPartnerPage();

        let _site = isPortal ? this._configurationService.portalId : this._configurationService.getCurrentSite();

        this.selectedValue = sessionStorage.getItem(`${variable}${_site}`);
        this.onSelect(this.selectedValue);
    }
}
